export default __webpack_public_path__ + "static/media/cont_ico_02.b2a9c04a.svg";